import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import api from "../../lib/apiClient";
import { ProHeader, StatusBadge, money, fmtDate, Loading, Empty } from "./proUi";

// Devis émis par le pro (GET /marketplace/quotes/mine). Les devis se créent depuis la
// messagerie d'une commande ; cette vue offre un suivi global (lecture seule ici).
export default function ProDevis() {
  const [quotes, setQuotes] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/marketplace/quotes/mine").then((r) => setQuotes(r.data.quotes)).catch(() => setQuotes([])); }, []);
  if (quotes === null) return <Loading />;
  const mine = quotes.filter((q) => q.is_pro);
  return (
    <div className="space-y-6" data-testid="pro-devis-page">
      <ProHeader eyebrow="Mon activité" title="Mes devis"
        subtitle="Retrouve tous les devis que tu as émis et leur statut." />
      {mine.length === 0 ? (
        <Empty icon={FileText} title="Aucun devis émis" hint="Lorsqu'un membre accepte ta proposition, tu peux lui envoyer un devis depuis la messagerie." testid="pro-devis-empty" />
      ) : (
        <div className="space-y-3">
          {mine.map((q) => (
            <div key={q.id} className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5" data-testid={`devis-${q.id}`}>
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-display font-bold text-zinc-100">{q.title}</h3>
                <StatusBadge status={q.status} />
              </div>
              <p className="text-xs text-zinc-500 mt-0.5">Client : {q.client_name} · {fmtDate(q.created_at)}</p>
              <div className="flex items-center gap-4 mt-3">
                <span className="font-display text-xl font-extrabold text-amber-400">{money(q.amount, q.currency)}</span>
                <span className="text-xs text-zinc-500">Net après commission : {money(q.pro_amount, q.currency)}</span>
                {q.order_id && (
                  <button onClick={() => nav("/pro/commandes")} data-testid={`devis-order-${q.id}`} className="ml-auto text-sm text-amber-400">Voir la commande</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
